import axios from "axios";
import React, { useEffect, useState } from "react";
import { baseImgURL, baseURL } from "./backend/baseData";
import { Link } from "react-router-dom";
import { Divider } from "@tremor/react";
import { RiArrowRightLine, RiAddCircleLine } from "@remixicon/react";

const ChallengesPage = () => {
  const [visits, setVisits] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchVisits = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getAllNormalChallenges.php?page_id=2`
        );
        if (response.status === 200 && Array.isArray(response.data)) {
          console.log(response.data);
          setVisits(response.data);
        } else {
          console.error("Invalid response format or failed to fetch visits");
          setVisits([]);
        }
      } catch (error) {
        console.error("Error while fetching visits:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVisits();
  }, []);
  return (
    <div>
      <div className="w-full shadow-slate-300">
        <div className="flex justify-end gap-2 w-full p-3">
          <Link className="w-fit p-3  bg-red-600 rounded-md flex gap-3 items-center" to={"/create-challenges"}>
            <RiAddCircleLine size={20} color="white" />
            <p className="text-white">Create</p>
          </Link>
          <Link className="w-fit p-3 bg-blue-400 rounded-md flex gap-3 items-center" to={"/create-tasks"}>
            <RiAddCircleLine size={20} color="white" />
            <p className="text-white">Create Tasks</p>
          </Link>
        </div>
      </div>
      <Divider />
      <div className="w-full grid grid-cols-12 mt-5 gap-2 p-3">
        {visits.length > 0 &&
          visits.map((item,index) => {
            return (
              <div key={index} className="col-span-12 md:col-span-6 max-h-32 mb-6 hover:scale-105 hover:duration-300 transition-all  ">
                <div className="w-full  bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 grid grid-cols-12">
                  <Link to="#" className="col-span-4 p-3">
                    <img
                      className="rounded-md  w-full object-cover max-h-[7.5rem] h-full"
                      src={baseImgURL + item.image}
                      alt={item.title}
                    />
                  </Link>
                  <div className="p-5 col-span-8">
                    <Link to="#">
                      <h5 className="mb-2 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                        {item.title}
                      </h5>
                    </Link>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400 text-sm">
                      {item.description && item.description.length > 150
                        ? `${item.description.substring(0, 150)}...`
                        : item.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ChallengesPage;
